(() => {
  'use strict';

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const round = (value, places = 1) => {
    const factor = 10 ** places;
    return Math.round(value * factor) / factor;
  };
  const inchesToCm = value => value * 2.54;
  const cmToInches = value => value / 2.54;

  function announce(message) {
    let toast = document.querySelector('.pf-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pf-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(announce.timer);
    announce.timer = setTimeout(() => toast.classList.remove('is-visible'), 2200);
  }

  function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  function svgToPng(svg, filename, width = 1400, height = 900, background = '#ffffff') {
    const clone = svg.cloneNode(true);
    clone.setAttribute('width', width);
    clone.setAttribute('height', height);
    const source = new XMLSerializer().serializeToString(clone);
    const blob = new Blob([source], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d');
      context.fillStyle = background;
      context.fillRect(0, 0, width, height);
      context.drawImage(image, 0, 0, width, height);
      URL.revokeObjectURL(url);
      canvas.toBlob(png => {
        if (png) downloadBlob(png, filename);
      }, 'image/png');
    };
    image.onerror = () => {
      URL.revokeObjectURL(url);
      announce('The PNG could not be created. Please try again.');
    };
    image.src = url;
  }

  window.PFUtils = { clamp, round, inchesToCm, cmToInches, announce, downloadBlob, svgToPng };
})();
